import { Component, OnInit } from '@angular/core';
import { BaseComponent } from './base.component';
import { LanguageService } from './language.service';
import { CampaignStateService } from './services/campaign-state.service';
import { takeUntil } from 'rxjs';

@Component({
    template: '', host: { 'data-component': 'campaign-language-base' },
    standalone: false
})
export class CampaignLanguageBaseComponent
  extends BaseComponent
  implements OnInit
{
  constructor(
    protected _languageService: LanguageService,
    protected _campaignStateService: CampaignStateService
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();    

    this._campaignStateService.currentSelectedCampaign$.pipe(takeUntil(this.destroy$)).subscribe(
      campaignInfo => {
        const languages = campaignInfo?.profile?.languages;
        if (languages && languages.length === 1) {
          const lang = languages[0];
          const campaignLanguage = lang.includes('en') ? 'en' : lang.includes('fr') ? 'fr' : null;
          if (campaignLanguage && campaignLanguage !== localStorage.getItem('lang')) {
            this._languageService.switchLanguage$.next(campaignLanguage);
          }
        }
      }
    );

    
  }
}
